export interface ComplianceDisclaimers {
    heading?: string;
    body: string;
}

export interface ComplianceDisclaimerBlock {
    rule: string;
    title?: string;
    sections: ComplianceDisclaimers[];
}

export const COMPLIANCE_DISCLAIMER_CATALOG: ComplianceDisclaimerBlock[] = [
    {
    rule: 'CADisclaimer',
    title: 'California Disclaimer',
    sections: [
      {
        heading: 'English',
        body: [
          'Western Reporting does not guarantee the accuracy or truthfulness of the information in this report as to the subject of the investigation, ',
          'but only that it is accurately copied from public records. Information generated as a result of identity theft, including evidence of criminal activity, ',
          'may be inaccurately associated with the consumer who is the subject of this report. Client agrees and certifies that its ordering of and use of this report is in strict',
          'compliance with any applicable local, state, and federal laws and regulations. In California, as a investigative consumer reporting agency (ICRA), Western Reporting',
          'shall provide a consumer seeking to obtain a copy of a report or making a request to review a file, a written notice in simple, plain English and Spanish setting forth the terms and conditions of his or her right to receive all disclosures under California law.'
        ].join(' ')
      },
      {
        heading: 'Spanish',
        body: [
          'Western Reporting no garantiza la exactitud o veracidad de la información en cuanto al objeto de la investigación, sino que solamente copia la información de los archivos públicos con exactitud. La información',
          'generada a raíz del robo de identidad, incluyendo evidencia de actividad criminal, puede ser incorrectamente asociada con el consumidor objeto de este informe.',
          'El cliente está de acuerdo y certifica que al ordenar y usar este informe está en estricto cumplimiento de cualesquiera leyes o regulaciones locales, estatales y federales que sean aplicables.',
          'En California, siendo una “agencia investigadora de información del consumidor” (ICRA, por sus siglas en inglés), Western Reporting proveerá, a cualquier consumidor que busque obtener copia de un informe o que solicite',
          'revisar los archivos, una notificación sencilla y clara, escrita en inglés y español, detallando los términos y condiciones de su derecho a recibir toda divulgación.'
        ].join(' ')
      }
    ]
  }
];